import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router'

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {

  constructor(private router: Router) {
    if ($('#chart_theme').length == 0)
      this.router.navigate([`/home/dashboard_sale`])


    // if ($('#chart_theme').length && $('#chart_theme').prop('href') == '') {
    //   $('#chart_theme').prop('href', 'assets/theme.css')
    //   this.router.navigate([`/home/dashboard_sale`])
    // }

    var link = document.createElement('link')
    link.id = 'chart_theme'
    link.rel = 'stylesheet'
    link.href = `assets/theme.css`
    document.head.append(link)
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.router.navigate([`/home/admin_dashboard`])
    }, 1000);
  }

  ngOnDestroy() {
    // setTimeout(() => {
    //   $('#chart_theme').prop('href', '')
    // }, 1000);
  }

}